//15-07-22 saloni
export const getLeftBlockStyles = (isSidebarCollapsed: boolean) => {
    if (isSidebarCollapsed) {
        return ({width:"79px"})
    }else {
        return ({width:"200px"})
    }
    
}

export const getRightBlockStyles = (isSidebarCollapsed: boolean) => {
    if (isSidebarCollapsed) {
        return ({width:"calc(100% - 79px) !important",height:"100vh"})
    }else {
        return ({width:"calc(100% - 200px) !important",height:"100vh"})
    }
    
}


